import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from './interactors';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
import { Util } from '../utils/Util';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { getRotationQuaternion } from '@egr/wcf/modules/core/utils/MeshUtils';
export class MoveGrid extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pPointIndex, pRoomElement) {
        this.mMode = pMode;
        this.mPointIndex = pPointIndex;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
        this.mInitialPointMove = true;
        this.mMoved = false;
        this.mRoomElement.setToolRunning(true);
        this.mRoomElement.setTransformStatus("Transform");
        this.mRoomElement.updateGeometry(false, false);
        this.prepareSnapping();
        //this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomElement.setMeshVisibility(1);
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updatePointerPosition(pPos) {
        let tREgeo = this.mRoomElement.geometry;
        let t_Points = tREgeo.getPoints();
        let tPoints = new Array();
        for (let tPoint of t_Points) {
            tPoints.push(tPoint.clone());
        }
        let tCenter = this.mRoomElement.geometry.center();
        let tRotation = getRotationQuaternion(this.mRoomElement.node).clone();
        let tM = new Matrix();
        tRotation.toRotationMatrix(tM);
        let tCenter_rot = Vector3.TransformCoordinates(tCenter, tM);
        let tnewPos = this.performSnapping(pPos);
        let tpointsPos = Util.to3d(Util.to2d(Vector3.TransformCoordinates(tnewPos, this.mRoomElement.transformInverted)));
        switch (this.mMode) {
            case MoveGrid.Mode.MovePoint:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                //tPoints[this.mPointIndex] = tiDiff_rot;
                tPoints[this.mPointIndex] = tpointsPos;
                switch (this.mPointIndex) {
                    case 0:
                        tPoints[1].x = tpointsPos.x;
                        tPoints[3].z = tpointsPos.z;
                        break;
                    case 1:
                        tPoints[0].x = tpointsPos.x;
                        tPoints[2].z = tpointsPos.z;
                        break;
                    case 2:
                        tPoints[1].z = tpointsPos.z;
                        tPoints[3].x = tpointsPos.x;
                        break;
                    case 3:
                        tPoints[0].z = tpointsPos.z;
                        tPoints[2].x = tpointsPos.x;
                        break;
                    default:
                        break;
                }
                let tL1 = Vector3.Distance(tPoints[0], tPoints[1]);
                let tL2 = Vector3.Distance(tPoints[0], tPoints[3]);
                if (tL1 >= 0.1 && tL2 >= 0.1) {
                    tREgeo.setPoints(tPoints);
                    this.mRoomElement.updateGeometry(false);
                }
                this.mMoved = false;
                break;
            case MoveGrid.Mode.MoveGrid:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                this.mRoomElement.setPosition(pPos.subtract(tCenter_rot));
                this.mMoved = true;
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (!this.mMoved) {
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tREgeo = this.mRoomElement.geometry;
            tREgeo.checkPointOrder();
            let tPoints = tREgeo.getPoints();
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tREgeo.setPoints(tPoints, true);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, false);
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
            if (this.mRoomElement.REforGrid_REF != null) {
                for (let tRE of this.mRoomElement.REforGrid_REF) {
                    const tcurrW = tRE.width;
                    const tcurrD = tRE.depth;
                    const tdiffWH = (this.mRoomElement.width - tcurrW) * 0.5;
                    const tdiffDH = (this.mRoomElement.depth - tcurrD) * 0.5;
                    const tLinePoints = tRE.Params.ElementPoints.slice();
                    for (let tP of tLinePoints) {
                        tP.addInPlace(new Vector3(-tdiffWH, 0, tdiffDH));
                    }
                    tRE.Params.ElementPoints = tLinePoints;
                    tRE.setWidth(this.mRoomElement.width, true, true);
                    tRE.setDepth(this.mRoomElement.depth, true, true);
                }
            }
        }
        this.mInitialPointMove = true;
        this.mRoomElement.setToolRunning(false);
        this.mRoomElement.updateGeometry();
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mRoomManager.TransformShape();
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        this.mRESnapping.prepareSnapping(this.mRoomElement);
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false, true);
    }
    updateFeedback() {
        super.updateFeedback();
        this.mRoomElement.showInteractors(false, true);
        if (this.mLengthFeedback != null)
            this.mLengthFeedback.showInteractors(false, true);
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    performSnapping(pPos) {
        return (this.mRESnapping.snap(pPos, this.mView));
    }
}
//add nested types
(function (MoveGrid) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MovePoint"] = 0] = "MovePoint";
        Mode[Mode["MoveGrid"] = 1] = "MoveGrid";
    })(Mode = MoveGrid.Mode || (MoveGrid.Mode = {}));
})(MoveGrid || (MoveGrid = {}));
